import styled from 'styled-components';

import { Body2, colors, spacing, smallShadow } from 'ui/theme';

export const Card = styled.div`
  border: ${`${spacing.single} solid ${colors.grey10}`};
  border-radius: ${spacing.half};
  padding: ${spacing.base} ${spacing.plusHalf};
  height: auto;
  background-color: ${colors.white};
`;

export const CampaignsCard = styled(Card)`
  display: flex;
  flex-direction: column;
  ${smallShadow};
`;

export const CardTitle = styled(Body2)`
  color: ${colors.textSecondary};
  margin: 0;
`;

export const BodyDisabled = styled(Body2)`
  color: ${colors.textDisabled};
  margin: 0;
`;

export const CampaignsDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.plusHalf};
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.base};
`;

export const AlignedDisabledText = styled(BodyDisabled)`
  text-align: center;
`;
